import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons/lib/icons";
import { Row, Steps } from "antd";
import React from "react";
const { Step } = Steps;

// Producto variable: el padre solo se crea en WooCommerce; ARI se usa al guardar
// cada variante (paso "Variantes").
const ReviewVariableProduct = ({ controlStatusGeneral }) => {
  const { step, status, messagestep3 } = controlStatusGeneral;
  const done = status === "success" && step === 4;
  const failed = status === "error";

  return (
    <Row justify="center" style={{ marginTop: "10px" }}>
      <Steps direction="vertical" style={{ maxWidth: 560 }}>
        <Step
          status={done ? "finish" : failed ? "error" : "process"}
          icon={
            done ? (
              <CheckCircleOutlined style={{ color: "green" }} />
            ) : failed ? (
              <CloseCircleOutlined style={{ color: "red" }} />
            ) : (
              <LoadingOutlined />
            )
          }
          title="Crear producto padre en WooCommerce"
          description={
            done
              ? "Producto variable creado correctamente"
              : failed
              ? messagestep3 || "No se pudo crear el producto en WooCommerce"
              : "Creando producto..."
          }
        />
      </Steps>
    </Row>
  );
};

export const ReviewProduct = ({ controlStatusGeneral, isVariable }) => {
  if (isVariable) {
    return <ReviewVariableProduct controlStatusGeneral={controlStatusGeneral} />;
  }
  return (
    <>
      <Row justify="center" style={{ marginTop: "10px" }}>
        <Steps direction="vertical" current={controlStatusGeneral.step}>
          <Step
            icon={
              controlStatusGeneral.step === 1 ? (
                <LoadingOutlined />
              ) : (
                <CheckCircleOutlined style={{ color: "green" }} />
              )
            }
            title="Obtener token"
            description={controlStatusGeneral.messagestep1}
          />
          <Step
            icon={
              controlStatusGeneral.step === 2 &&
              controlStatusGeneral.status === "loading" ? (
                <LoadingOutlined />
              ) : controlStatusGeneral.step !== 2 &&
                controlStatusGeneral.status === "success" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                controlStatusGeneral.step === 2 &&
                controlStatusGeneral.status === "error" && (
                  <CloseCircleOutlined style={{ color: "red" }} />
                )
              )
            }
            title="Crear producto ARI"
            description={controlStatusGeneral.messagestep2}
          />
          <Step
            icon={
              controlStatusGeneral.step === 3 &&
              controlStatusGeneral.status === "loading" ? (
                <LoadingOutlined />
              ) : (
                controlStatusGeneral.step !== 3 &&
                controlStatusGeneral.status === "success" && (
                  <CheckCircleOutlined style={{ color: "green" }} />
                )
              )
            }
            title="Crear Producto"
            description={controlStatusGeneral.messagestep3}
          />
        </Steps>
      </Row>
    </>
  );
};
